module.exports = __webpack_public_path__ + "media/images/country_flags/sd-0b56958aae2fa73c080ab443c690d432.png";